// extracted by mini-css-extract-plugin
export default {"link":"EntityTableRedirectLink_link__CKaxW","content":"EntityTableRedirectLink_content__8FlgE","icon":"EntityTableRedirectLink_icon__4-CFH"};